import { combineReducers } from "redux";
import quizDataReducer from "./quizDataReducer";
import registeredUserReducer from "./registeredUserReducer";

const allReducers = combineReducers({
	quizData: quizDataReducer,
	registeredUser: registeredUserReducer
});

export default allReducers;
